import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, spacing, typography } from '@/styles/designTokens'

export const ModifierRow = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'depth',
})<{ depth: number }>(({ depth }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	paddingLeft: depth > 0 ? depth * spacing.md : 0,
}))

export const ModifierLabel = styled('p')({
	margin: 0,
	color: colors.textSecondary,
	fontSize: typography.fontSizeSm,
	lineHeight: typography.lineHeightMd,
})

export const ModifierPrice = styled('span')({
	color: colors.textSecondary,
	fontSize: typography.fontSizeSm,
	lineHeight: typography.lineHeightMd,
	flexShrink: 0,
	marginLeft: `${spacing.xs}px`,
})
